import { OGP } from '@levelworks/shared-backend-api';
import { QUERY_KEYS } from 'api/query-keys';
import { workersPoolsService } from 'ogp/services';
import { useMutation, useQueryClient } from 'react-query';

type UpdateWorkersPoolVariables = {
  workersPoolId: string;
  body: OGP.UpdateWorkersPoolRequestDto;
};

export const useUpdateWorkersPool = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ workersPoolId, body }: UpdateWorkersPoolVariables) =>
    await workersPoolsService.updateWorkersPool(workersPoolId, body);

  return useMutation(mutationFn, {
    onSettled: async () => {
      queryClient.invalidateQueries(QUERY_KEYS.flexPools());
    },
  });
};
